import Typography from "@mui/material/Typography";
import React from "react";


export default  function Footer(props) {

    return (
        <footer>

            <div className="social-media-icons">
                <Typography variant="body2" color="text.secondary" align="center" {...props}>
                    {'Copyright © '}

                    Acil Çocuk Doktoru
                    {' |  '}
                    {new Date().getFullYear()}
                    {/* {'.'} */}
                    {<br/>}
                    <a style={{fontSize:11}} href={'https://acilcocukdoktoru.com/public/kullanici_aydinlatma_metni.pdf'}>Aydınlatma Metni</a>
                    {' | '}
                    <a style={{fontSize:11}} href="https://acilcocukdoktoru.com/public/kullanici_sozlesmesi.pdf" target="_blank"
                       rel="noopener noreferrer">
                        Kullanıcı Sözleşmesi
                    </a>

                    {'  |  '}
                    <a style={{fontSize:11}} href={'mailto:info@acilcocukdoktoru.com'}>info@acilcocukdoktoru.com</a>
                </Typography>

            </div>
        </footer>

    );
}